export type User = {
  uid: string
  email: string
  displayName: string // ชื่อสำหรับ user, shop
  title: string
  firstName: string
  lastName: string
  imageUrl: string // profile สำหรับ user, shop
  phoneNumber: string // เบอร์โทรสำหรับ user, shop
  role: Role

  // สำหรับ shop
  lineId: string
  lineGroupId: string
  shopCoverUrl: string
  shopBannerUrl: string
  shopDescription: string
  shopStatus: ShopStatus

  refCode: string

  otp: string
  otpExpireAt: Date

  isVerified: boolean
  isShowPwa?: boolean

  memberCode: string

  authProvider: AuthProvider

  needChangePassword: boolean

  createdAt: Date
  updatedAt: Date
}

export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
  SHOP = 'SHOP',
}

export enum ShopStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

/**
 * All editable fields of the User type.
 * This type is generated from the User type keys.
 */
export type UserEditableField = Extract<
  keyof User,
  | 'displayName'
  | 'title'
  | 'firstName'
  | 'lastName'
  | 'phoneNumber'
  | 'imageUrl'
  | 'phoneNumber'
  | 'shopCoverUrl'
  | 'shopBannerUrl'
  | 'shopDescription'
  | 'shopStatus'
>

export enum AuthProvider {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
  LINE = 'LINE',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}
